import { Nullable } from '~/eds/src/types/Nullable';

import { Citation } from '../types/chat';

export const testIsTicketCitation = (citation: Citation) =>
  citation.entity?.type === 'ticket';

export const testIsFieldCitation = (citation: Citation) =>
  citation.entity?.type === 'field';

export const shouldOpenDetailsRightPanel = (
  citation: Nullable<Citation>,
): citation is Citation => !!citation && testIsFieldCitation(citation);
